/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/img/logo.png";
import { HashLink } from "react-router-hash-link";
import "./NavBar.css";
import LanguageButton from "./LanguageButton";
import { useTranslation } from "react-i18next";

export default function NavBar(): JSX.Element {
  const { t } = useTranslation();

  const [activeLink, setActiveLink] = useState<string>("home");
  const [scrolled, setScrolled] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = (): void => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onUpdateActiveLink = (value: string): void => {
    setActiveLink(value);
  };

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="/">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              href="#home"
              className={activeLink === "home" ? "active navbar-link" : "navbar-link"}
              onClick={() => {
                onUpdateActiveLink("home");
              }}
            >
              {t("Home")}
            </Nav.Link>
            <Nav.Link
              href="#projects"
              className={activeLink === "projects" ? "active navbar-link" : "navbar-link"}
              onClick={() => {
                onUpdateActiveLink("projects");
              }}
            >
              {t("Projects")}
            </Nav.Link>
            <Nav.Link
              href="#connect"
              className={activeLink === "contact" ? "active navbar-link" : "navbar-link"}
              onClick={() => {
                onUpdateActiveLink("connect");
              }}
            >
              {t("Contact")}
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <HashLink to="#connect">
              <button className="vvd">
                <span>{t("Let's Connect")}</span>
              </button>
            </HashLink>
            <div className="language-switch">
              <LanguageButton />
            </div>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
